import React from 'react';
import { createRoot } from 'react-dom/client';

import { Header } from './Header';

import type { HeaderData } from './types';

declare global {
  interface Window {
    InteractHeaderData?: HeaderData;
  }
}

const mountNode = document.getElementById('interact-header-react-root');
const headerData = window.InteractHeaderData;

if (mountNode && headerData) {
  const root = createRoot(mountNode);
  root.render(
    <React.StrictMode>
      <Header data={headerData} />
    </React.StrictMode>,
  );
} else if (!headerData) {
  // eslint-disable-next-line no-console
  console.warn('Interact header data is not available.');
}
